import { Tooltip } from "antd";
import { TooltipProps } from "antd/lib";

import style from "./AntTooltip.module.scss";

const AntTooltip = (props: TooltipProps) => {
  return (
    <Tooltip
      {...props}
      className={style.tooltip}
      rootClassName={props.className}
    >
      {props.children}
    </Tooltip>
  );
};

export default AntTooltip;
